// extracted by mini-css-extract-plugin
export default {"deleteButton":"ImportStep_deleteButton__pBDs5","fieldBox":"ImportStep_fieldBox__p4TtO","fieldWrapper":"ImportStep_fieldWrapper__xXa9e","text":"ImportStep_text__Vh3hl"};